module.exports = __webpack_public_path__ + "static/media/layer4.1760ef07.svg";